// src/LoginForm.js
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, API_BASE, setStoreIdHeader, setUserHeader } from "./api";

export default function LoginForm() {
  const navigate = useNavigate();

  const [storeId, setStoreId] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const savedStore = localStorage.getItem("saved_store_id") || "";
    const savedUser = localStorage.getItem("saved_username") || "";
    if (savedStore) setStoreId(savedStore);
    if (savedUser) setUsername(savedUser);
  }, []);

  const showError = (txt) => setMessage(String(txt || "Login failed"));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const sid = Number(storeId || 0);
    const u = username.trim();
    const p = String(password || "");

    if (!sid || sid <= 0) return showError("⚠️ Enter a valid Store ID");
    if (!u || !p) return showError("⚠️ Username and password required");

    setStoreIdHeader(sid);

    setLoading(true);
    try {
      const res = await api.post("/login", {
        store_id: sid,
        username: u,
        password: p,
      });
if (res.data?.success) {

  const storeFromApi = Number(
    res.data?.store_id || res.data?.user?.store_id || sid
  );

  const userObj = res.data?.user || { username: u };
  const finalUsername = String(userObj?.username || u);

  const storeType = String(
    res.data?.user?.store_type ||
    res.data?.store_type ||
    userObj?.store_type ||
    "retail"
  ).toLowerCase();

  localStorage.setItem("store_id", String(storeFromApi));
  localStorage.setItem("saved_store_id", String(sid));
  localStorage.setItem("saved_username", u);

  localStorage.setItem("user", JSON.stringify(userObj));
  localStorage.setItem("username", finalUsername);
  localStorage.setItem("store_type", storeType);
  localStorage.setItem("store_name", res.data?.user?.store_name || "");

  if (userObj?.role) {
    localStorage.setItem("role", String(userObj.role).toLowerCase());
  }

  if (userObj?.store_id) {
    localStorage.setItem("user_store_id", String(userObj.store_id));
  }

  setStoreIdHeader(storeFromApi);
  setUserHeader(finalUsername);

  navigate("/dashboard", { replace: true });
  return;
}

      showError(res.data?.message || "❌ Invalid credentials");
    } catch (err) {
      const msg =
        err?.userMessage ||
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Login failed";

      showError(`❌ ${msg}`);
      console.error("[Login] error:", err, "API:", API_BASE);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <form className="card" onSubmit={handleSubmit} noValidate>
        <div className="brand">
          <div className="brand-text">
            <div className="brand-title">KEVSOFT POS</div>
            <div className="brand-sub">Point of Sale</div>
          </div>
        </div>

        <h2 className="signin">Sign In</h2>

        <div className="api-pill">
          API: <code>{API_BASE}</code>
        </div>

        {message && (
          <div className="alert" role="alert">
            {message}
          </div>
        )}

        <div className="field">
          <label className="label">Store ID</label>
          <input
            type="number"
            inputMode="numeric"
            placeholder="e.g., 1"
            value={storeId}
            onChange={(e) => setStoreId(e.target.value)}
            className="input"
            disabled={loading}
          />
        </div>

        <div className="field">
          <label className="label">Username</label>
          <input
            type="text"
            placeholder="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            className="input"
            disabled={loading}
          />
        </div>

        <div className="field">
          <label className="label">Password</label>
          <input
            type="password"
            placeholder="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            className="input"
            disabled={loading}
          />
        </div>

        <button
          className="btn"
          type="submit"
          disabled={loading}
          aria-busy={loading}
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>

        <p className="signup">
          Do not have an account?{" "}
          <Link to="/register-store" className="link-accent">
            Register Store
          </Link>
        </p>

        <style>{`
          :root{
            --panel:#fff; --ink:#111827; --muted:#6b7280; --border:#d1d5db;
            --error:#dc2626; --title:#e53935; --button:#2e6da4; --button-700:#245585;
            --focus-ring: rgba(59,130,246,.15);
          }
          *{box-sizing:border-box} body{margin:0}
          .auth-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;background:#f7f8fa;padding:20px;}
          .card{width:min(380px,92vw);background:var(--panel);border:1px solid #e5e7eb;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.08);padding:20px 22px 24px;color:var(--ink);text-align:center;}
          .brand{display:flex;align-items:center;justify-content:center;margin-bottom:6px;}
          .brand-title{font-weight:800;letter-spacing:.2px;color:var(--title);font-size:22px;}
          .brand-sub{margin-top:2px;color:#6b7280;font-size:13px;}
          .signin{margin:12px 0 14px;font-size:20px;font-weight:700;}
          .api-pill{font-size:12px;background:#eef2ff;border:1px solid #c7d2fe;color:#3730a3;border-radius:999px;padding:4px 10px;margin:0 auto 8px;width:max-content;}
          .alert{margin:10px 0;padding:10px 12px;border-radius:10px;background:#fff1f2;border:1px solid #fecdd3;color:#9f1239;font-size:13px;text-align:left;white-space:pre-wrap;}
          .field{margin:10px 0;text-align:left;}
          .label{display:block;font-size:12px;color:#374151;margin-bottom:6px;font-weight:700;}
          .input{width:100%;padding:10px 12px;border:1px solid var(--border);border-radius:10px;outline:none;font-size:14px;}
          .input:focus{box-shadow:0 0 0 4px var(--focus-ring);border-color:#60a5fa;}
          .btn{width:100%;padding:10px 12px;border:none;border-radius:10px;background:var(--button);color:white;font-weight:700;cursor:pointer;margin-top:10px;}
          .btn:disabled{opacity:.7;cursor:not-allowed;}
          .btn:hover{background: var(--button-700);}
          .signup{margin:14px 0 0;font-size:13px;color:#374151;}
          .link-accent{color:#2563eb;text-decoration:none;font-weight:700;}
          .link-accent:hover{text-decoration:underline;}
        `}</style>
      </form>
    </div>
  );
}